import React from 'react';
import { Shield } from 'lucide-react';
import { Section } from './Shared';
import { WhatsAppIcon, WHATSAPP_URL } from './WhatsAppButton';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-90" data-mp="3gh3sii3dgcgq">
    <div className="glass-panel p-8 md:p-12 rounded-3xl text-center border-brand-goldDark/30" data-id="element-91" data-mp="32onj8zjvni7d">
      <Shield className="w-10 h-10 md:w-12 md:h-12 text-brand-goldDark mx-auto mb-5" strokeWidth={1.25} data-id="element-92" data-mp="36oxw8w6378vq" />
      <h2 className="text-lg md:text-2xl font-display font-bold uppercase tracking-[0.14em] mb-4 text-brand-burgundy" data-id="element-93" data-mp="3uesc7mlpddk7">
        Garantía 7 días — sin preguntas
      </h2>
      <p className="text-brand-text mb-4 text-base md:text-lg" data-id="element-94" data-mp="3lec9wggp4cgx">
        Abrís los tomos. Aplicás los protocolos. Los usás en tu consultorio.
      </p>
      <p className="text-brand-text mb-6 text-base md:text-lg" data-id="element-95" data-mp="3qc44ji8q6cot">
        Si en 7 días no es exactamente lo que esperabas: devolución del 100% sin
        formularios, sin drama, sin preguntas.
      </p>
      <p className="font-medium text-brand-purple text-sm md:text-base" data-id="element-96" data-mp="2ezuvvrhbmiod">
        Tasa de devoluciones: menos del 1%.
      </p>
    </div>
  </Section>;
export const Footer = () => <footer className="bg-brand-purpleDark text-brand-surface/85 py-12 border-t border-brand-gold/30" data-id="element-97" data-mp="3gb8xh6j7rkx6">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-98" data-mp="3v8rhxwouzbyt">
      <div className="mb-8" data-id="element-99" data-mp="3q8wp3nliwcb4">
        <h3 className="font-display font-bold text-xl uppercase tracking-[0.3em] text-brand-goldLight mb-3" data-id="element-100" data-mp="3q7llbns2v4k0">
          Lumen Akasha
        </h3>
        <p className="text-white/75" data-id="element-101" data-mp="80nrednpyga8">
          El sistema clínico N°1 para terapeutas de Chi Kung en Argentina.
        </p>
        <p className="text-white/75 mt-2" data-id="element-102" data-mp="hsk0ejrcfqt8">
          Porque aplicar Chi Kung con excelencia no debería costarte la
          seguridad ni la energía de tu consultorio.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8 mb-12 text-sm" data-id="element-103" data-mp="qt8ipqnrsdbx">
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-brand-goldLight transition-colors" data-id="element-104" data-mp="msy1fhuj20hr">
          <WhatsAppIcon className="w-4 h-4 shrink-0" data-id="element-105" data-mp="yu7h6qjrtnxo" />
          +54 9 11 5339-9780
        </a>
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-goldLight transition-colors" data-id="element-106" data-mp="13tan0d7kry6p">
          📧 soportelumenakasha@gmail.com
        </a>
        <a href="https://instagram.com/lumen.akasha" className="hover:text-brand-goldLight transition-colors" data-id="element-107" data-mp="18lkbdot1kq6v">
          📲 @lumen.akasha
        </a>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-goldLight transition-colors" data-id="element-108" data-mp="1hkfhz20002ap">
          🌐 www.lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-white/50 space-y-2" data-id="element-109" data-mp="1mhpcux65p65x">
        <p data-id="element-110" data-mp="1rj4vkikv30l5">
          © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
        <p data-id="element-111" data-mp="3ta8c1ohfn9dm">Ley 25.326 — Protección de Datos Personales — República Argentina</p>
      </div>

      <div className="mt-8" data-id="element-112" data-mp="2af3rlmvaexi1">
        <p className="text-sm font-serif italic text-brand-goldLight/70" data-id="element-113" data-mp="2afdjjfzw7eqd">
          🌿 "El terapeuta que tiene un sistema aplica con confianza. El que
          aplica con confianza genera resultados. El que genera resultados
          crece."
        </p>
      </div>
    </div>
  </footer>;